module.exports = __webpack_public_path__ + "img/pexels-tima-miroshnichenko-5355917.d1d0951c.jpg";